import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbBarComponent } from '../components/breadcrumb-bar/breadcrumb-bar.component';
import { SelectDropdownDirective } from '../directives/select-dropdown.directive';
import { AccordionActiveDirective } from '../directives/accordion-active';
import { AsteriskDirective } from '../directives/asterisk.directive';
import { SliderDirective } from '../directives/slider.directive';
import { TogglePasswordDirective } from '../directives/toggle-password.directive';
import { CaptchaDirective } from '../directives/captcha.directive';
import { DateFormatDirective } from '../directives/date-format.directive';
import { GetTagsPipe } from '../pipes/get-tags.pipe';
import { TranslatePipe } from '../pipes/translate.pipe';
import { FileUploadDirective } from '../directives/file-upload.directive';
import { ThemeSwitchPipe } from '../pipes/theme-switch.pipe';
import { PaginationDirective } from '../directives/pagination.directive';
import { UpdateCaptchaDirective } from '../directives/update-captcha.directive';
import { CaptchaComponent } from '../components/captcha/captcha.component';
import { ResponsiveColumnsDirective } from '../directives/responsive-columns.directive';
import { DateTimeFormatDirective } from '../directives/date-time-format.directive';
import { AlphabetOnlyDirective } from '../directives/alphabetOnly.directive';
import { RestrictSpecialCharactersDirective } from '../directives/restrictSpecialCharacters.directive';
import { EmailCharacterRestrictionDirective } from '../directives/emailValidation.directive';
import { DescriptionRestrictionDirective } from '../directives/allowDescription.directive';
import { NumbersOnlyDirective } from '../directives/numbersOnly.directive';
import { TooltipDirective } from '../directives/toolTip.directive';
import { TextToSpeechDirective } from '../directives/text-to-speech.directive';
import { RemarksRestrictionDirective } from '../directives/allowRemarks.directive';
import { SanitizeInputDirective } from '../directives/sanitize-input.directive';


@NgModule({
  declarations: [
    SelectDropdownDirective,
    AccordionActiveDirective,
    AsteriskDirective,
    SliderDirective,
    TogglePasswordDirective,
    CaptchaDirective,
    DateFormatDirective,
    FileUploadDirective,
    PaginationDirective,
    UpdateCaptchaDirective,
    GetTagsPipe,
    TranslatePipe,
    ThemeSwitchPipe,
    CaptchaComponent,
    ResponsiveColumnsDirective,
    DateTimeFormatDirective,
    AlphabetOnlyDirective,
    RestrictSpecialCharactersDirective,
    EmailCharacterRestrictionDirective,
    DescriptionRestrictionDirective,
    NumbersOnlyDirective,
    TooltipDirective,
    TextToSpeechDirective,
    RemarksRestrictionDirective,
    SanitizeInputDirective,
    BreadcrumbBarComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    SelectDropdownDirective,
    AccordionActiveDirective,
    AsteriskDirective,
    SliderDirective,
    TogglePasswordDirective,
    CaptchaDirective,
    DateFormatDirective,
    FileUploadDirective,
    PaginationDirective,
    UpdateCaptchaDirective,
    GetTagsPipe,
    TranslatePipe,
    ThemeSwitchPipe,
    ResponsiveColumnsDirective,
    DateTimeFormatDirective,
    AlphabetOnlyDirective,
    RestrictSpecialCharactersDirective,
    EmailCharacterRestrictionDirective,
    DescriptionRestrictionDirective,
    NumbersOnlyDirective,
    TooltipDirective,
    TextToSpeechDirective,
    RemarksRestrictionDirective,
    SanitizeInputDirective,
    BreadcrumbBarComponent
  ],
  providers: [ThemeSwitchPipe]
})
export class SharedModule { }
